module.exports = function(pages) {
	'use strict'
	pages.directive('allPagesDir',allPagesDir);
	allPagesDir.$inject=[];
	function allPagesDir() {
		return {
			restrict: 'E',
			template: require('./partial/allpages.html'),
			controller:'allpagesController',
			controllerAs:'vmapg',
			link: function(scope, element, attrs, ctrl) {
				
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/pagesModule/allpages/js/directive/allpagesDirective.js
// module id = 536
// module chunks = 0